@charset "UTF-8";

/* src/app/documents/documents.component.scss */
.documents-page {
  --primary: #253b80;
  --primary-dark: #1d2f68;
  --text: #172033;
  --muted: #6b7280;
  --border: #e5e7eb;
  --background: #f5f7fb;
  --surface: #ffffff;
  --success: #16a34a;
  min-height: 100%;
  padding: 3px 20px 0px 32px;
  background: var(--background);
  color: var(--text);
}
.page-content {
  padding: 20px 0 !important;
}
.documents-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}
.documents-page__title-area {
  display: flex;
  align-items: center;
  gap: 14px;
}
.documents-page__icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background: rgba(37, 59, 128, 0.1);
  color: var(--primary);
  font-size: 21px;
}
.documents-page__title-area h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 750;
  letter-spacing: -0.4px;
}
.documents-page__title-area p {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 13px;
}
.documents-page__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.documents-workspace {
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  min-height: calc(100vh - 103px);
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.04);
  transition: grid-template-columns 0.25s ease;
}
.documents-workspace.sidebar-collapsed {
  grid-template-columns: 72px minmax(0, 1fr);
}
.folder-sidebar {
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: #fbfcfe;
  border-right: 1px solid #e5e7eb;
  overflow: hidden;
  transition: width 0.25s ease;
}
.folder-sidebar__header {
  min-height: 68px;
  padding: 0 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-bottom: 1px solid #e5e7eb;
}
.folder-sidebar__heading {
  min-width: 0;
  overflow: hidden;
}
.folder-sidebar__heading h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 750;
  color: #172033;
}
.folder-sidebar__heading span {
  display: block;
  margin-top: 3px;
  color: #6b7280;
  font-size: 11px;
}
.sidebar-toggle {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  transition: all 0.18s ease;
}
.sidebar-toggle:hover {
  background: #eef2ff;
  border-color: #d5dcf2;
  color: #253b80;
}
.folder-search {
  position: relative;
  margin: 14px;
}
.folder-search i {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 13px;
}
.folder-search input {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  padding: 0 10px 0 34px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  outline: none;
  background: #fff;
  font-size: 12px;
}
.folder-search input:focus {
  border-color: #9ca8c9;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.06);
}
.folder-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.folder-list::-webkit-scrollbar {
  width: 5px;
}
.folder-list::-webkit-scrollbar-track {
  background: transparent;
}
.folder-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.folder-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.folder-item {
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px;
  margin-bottom: 3px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: all 0.18s ease;
}
.folder-item:hover {
  background: #f0f3f9;
}
.folder-item.active {
  background: rgba(37, 59, 128, 0.09);
}
.folder-item.active .folder-item__icon {
  background: #253b80;
  color: #fff;
}
.folder-item.active .folder-item__name {
  color: #253b80;
  font-weight: 700;
}
.folder-item.active .folder-item__arrow {
  color: #253b80;
  opacity: 1;
}
.folder-item {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  cursor: pointer;
}
.folder-item__actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
}
.folder-edit-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  border-radius: 6px;
  color: #94a3b8;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition:
    color 0.2s ease,
    background 0.2s ease,
    opacity 0.2s ease;
}
.folder-edit-btn i {
  font-size: 14px;
}
.folder-edit-btn:hover {
  color: #253b80;
  background: #fef2f2;
}
.folder-delete-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  border-radius: 6px;
  color: #94a3b8;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition:
    color 0.2s ease,
    background 0.2s ease,
    opacity 0.2s ease;
}
.folder-delete-btn i {
  font-size: 14px;
}
.folder-delete-btn:hover {
  color: #dc2626;
  background: #fef2f2;
}
.folder-item:hover .folder-edit-btn,
.folder-item:hover .folder-delete-btn {
  opacity: 1;
  visibility: visible;
}
.folder-item__icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef1f6;
  color: #64748b;
  font-size: 14px;
  transition: all 0.18s ease;
}
.folder-item__icon.all {
  background: rgba(37, 59, 128, 0.1);
  color: #253b80;
}
.folder-item__content {
  min-width: 0;
  flex: 1;
  overflow: hidden;
}
.folder-item__name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #374151;
  font-size: 12.5px;
  font-weight: 600;
}
.folder-item__count {
  display: block;
  margin-top: 2px;
  color: #9ca3af;
  font-size: 10.5px;
}
.folder-item__arrow {
  opacity: 0;
  font-size: 10px;
  transition: opacity 0.18s ease;
}
.folder-item:hover .folder-item__arrow {
  opacity: 1;
}
.documents-workspace.sidebar-collapsed .folder-sidebar__header {
  justify-content: center;
  padding: 0 8px;
}
.documents-workspace.sidebar-collapsed .sidebar-toggle {
  width: 36px;
  height: 36px;
}
.documents-workspace.sidebar-collapsed .folder-list {
  padding: 10px 8px;
}
.documents-workspace.sidebar-collapsed .folder-item {
  justify-content: center;
  padding: 6px;
}
.documents-workspace.sidebar-collapsed .folder-item__icon {
  width: 42px;
  height: 42px;
  flex-basis: 42px;
  border-radius: 11px;
}
.documents-content {
  min-width: 0;
  padding: 22px;
  background: #fff;
  transition: padding 0.25s ease;
}
@media (max-width: 850px) {
  .documents-workspace {
    grid-template-columns: 1fr;
  }
  .documents-workspace.sidebar-collapsed {
    grid-template-columns: 1fr;
  }
  .folder-sidebar {
    display: none;
  }
}
.btn {
  height: 40px;
  padding: 0 15px;
  border: 0;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-primary {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 4px 12px rgba(37, 59, 128, 0.18);
}
.btn-primary:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
}
.btn-light {
  background: #fff;
  color: #374151;
  border: 1px solid var(--border);
}
.btn-light:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}
.btn-ai {
  background: #eef2ff;
  color: var(--primary);
  border: 1px solid #dbe2ff;
}
.btn-ai:hover {
  background: #e2e8ff;
}
.btn-ai:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.btn-sm {
  height: 34px;
  padding: 0 12px;
}
.documents-workspace {
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  min-height: calc(100vh - 103px);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.04);
}
.folder-sidebar {
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: #fbfcfe;
  border-right: 1px solid var(--border);
}
.folder-sidebar__header {
  padding: 18px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border);
}
.folder-sidebar__header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 750;
}
.folder-sidebar__header span {
  display: block;
  margin-top: 3px;
  color: var(--muted);
  font-size: 11px;
}
.icon-button {
  width: 32px;
  height: 32px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--primary);
  cursor: pointer;
}
.icon-button:hover {
  background: #f3f5fb;
}
.folder-search {
  position: relative;
  margin: 14px;
}
.folder-search i {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 13px;
}
.folder-search input {
  width: 100%;
  height: 36px;
  padding: 0 10px 0 34px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  outline: none;
  font-size: 12px;
  box-sizing: border-box;
}
.folder-search input:focus {
  border-color: #aab6d7;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.07);
}
.folder-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 9px;
}
.folder-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  margin-bottom: 3px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
}
.folder-item:hover {
  background: #f0f3f9;
}
.folder-item.active {
  background: rgba(37, 59, 128, 0.09);
}
.folder-item.active .folder-item__name {
  color: var(--primary);
  font-weight: 700;
}
.folder-item.active .folder-item__icon {
  background: var(--primary);
  color: #fff;
}
.folder-item.active .folder-item__arrow {
  opacity: 1;
  color: var(--primary);
}
.folder-item__icon {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef1f6;
  color: #64748b;
  font-size: 14px;
}
.folder-item__icon.all {
  background: rgba(37, 59, 128, 0.1);
  color: var(--primary);
}
.folder-item__content {
  min-width: 0;
  flex: 1;
}
.folder-item__name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12.5px;
  font-weight: 600;
  color: #374151;
}
.folder-item__count {
  display: block;
  margin-top: 2px;
  color: #9ca3af;
  font-size: 10.5px;
}
.folder-item__arrow {
  opacity: 0;
  font-size: 11px;
}
.folder-sidebar__footer {
  padding: 15px;
  border-top: 1px solid var(--border);
}
.storage-info__top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
  font-size: 11px;
  color: var(--muted);
}
.storage-info__top strong {
  color: var(--text);
}
.storage-progress {
  height: 5px;
  overflow: hidden;
  border-radius: 10px;
  background: #e5e7eb;
}
.storage-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--primary);
}
.storage-info small {
  display: block;
  margin-top: 6px;
  color: #9ca3af;
  font-size: 10px;
}
.documents-content {
  min-width: 0;
  padding: 22px;
  background: #fff;
}
.documents-content__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}
.documents-content__heading {
  min-width: 0;
}
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #9ca3af;
  font-size: 12px;
}
.breadcrumb i {
  font-size: 9px;
}
.breadcrumb strong {
  color: var(--text);
  font-weight: 700;
}
.document-count {
  margin-top: 5px;
  color: var(--muted);
  font-size: 11px;
}
.documents-content__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.view-switch {
  display: flex;
  padding: 3px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #f9fafb;
}
.view-switch button {
  width: 32px;
  height: 30px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
}
.view-switch button.active {
  background: #fff;
  color: var(--primary);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.documents-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 18px;
}
.documents-search {
  position: relative;
  width: min(420px, 100%);
}
.documents-search i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 13px;
}
.documents-search input {
  width: 100%;
  height: 38px;
  padding: 0 12px 0 36px;
  box-sizing: border-box;
  border: 1px solid var(--border);
  border-radius: 9px;
  outline: none;
  font-size: 12px;
}
.documents-search input:focus {
  border-color: #aab6d7;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.06);
}
.documents-toolbar__right {
  display: flex;
  align-items: center;
  gap: 7px;
}
.filter-button,
.sort-button {
  height: 36px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 0 11px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: #4b5563;
  font-size: 11px;
  cursor: pointer;
}
.sort-button i:last-child {
  font-size: 9px;
}
.document-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  padding: 4px 2px 24px;
  max-height: calc(100vh - 337px);
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.document-grid::-webkit-scrollbar {
  width: 7px;
}
.document-grid::-webkit-scrollbar-track {
  background: transparent;
}
.document-grid::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.document-grid::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.document-card {
  position: relative;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: visible;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 16px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.03), 0 8px 24px rgba(15, 23, 42, 0.04);
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}
.document-card:hover {
  transform: translateY(-3px);
  border-color: #d8deeb;
  box-shadow: 0 5px 12px rgba(15, 23, 42, 0.05), 0 16px 35px rgba(15, 23, 42, 0.08);
}
.document-card__preview {
  position: relative;
  min-height: 148px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  border-radius: 16px 16px 0 0;
  overflow: visible;
  background:
    linear-gradient(
      145deg,
      #f8faff 0%,
      #f1f5ff 100%);
}
.document-card__preview.pdf {
  background:
    linear-gradient(
      145deg,
      #fff7f7,
      #fff1f1);
}
.document-card__preview.doc,
.document-card__preview.docx {
  background:
    linear-gradient(
      145deg,
      #f5f8ff,
      #eef4ff);
}
.document-card__preview.xls,
.document-card__preview.xlsx {
  background:
    linear-gradient(
      145deg,
      #f3fbf6,
      #ecf8f1);
}
.document-card__preview.ppt,
.document-card__preview.pptx {
  background:
    linear-gradient(
      145deg,
      #fff9f2,
      #fff3e6);
}
.document-card__file-icon {
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);
}
.document-card__file-icon i {
  font-size: 30px;
  color: #253b80;
}
.document-card__file-type {
  padding: 4px 9px;
  border-radius: 6px;
  background: rgba(37, 59, 128, 0.08);
  color: #253b80;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.7px;
}
.document-card__menu-wrapper {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 20;
}
.document-card__menu {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.9);
  color: #64748b;
  cursor: pointer;
  box-shadow: 0 3px 8px rgba(15, 23, 42, 0.08);
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.document-card__menu i {
  font-size: 15px;
}
.document-card__menu:hover {
  background: #ffffff;
  color: #253b80;
  transform: scale(1.05);
}
.document-card__dropdown {
  position: absolute;
  top: 40px;
  right: 0;
  width: 205px;
  padding: 7px;
  background: #ffffff;
  border: 1px solid #e5e9f1;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.13), 0 3px 8px rgba(15, 23, 42, 0.06);
  z-index: 100;
  animation: documentDropdownIn 0.15s ease-out;
}
.document-card__dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.document-card__dropdown-item:hover {
  background: #f5f7fb;
  color: #253b80;
}
.document-card__dropdown-item--danger:hover {
  background: #fff5f5;
  color: #dc2626;
}
.dropdown-icon {
  width: 29px;
  height: 29px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 7px;
  font-size: 13px;
  background: #f1f5f9;
  color: #64748b;
}
.dropdown-icon--edit {
  background: #eff6ff;
  color: #2563eb;
}
.dropdown-icon--download {
  background: #f0fdf4;
  color: #16a34a;
}
.dropdown-icon--delete {
  background: #fef2f2;
  color: #dc2626;
}
.dropdown-icon--assessment {
  background: #f5f3ff;
  color: #7c3aed;
}
.dropdown-icon--survey {
  background: #fff7ed;
  color: #ea580c;
}
.dropdown-icon--poll {
  background: #ecfeff;
  color: #0891b2;
}
.dropdown-icon--notes {
  background: #fffbeb;
  color: #d97706;
}
.document-card__dropdown-divider {
  height: 1px;
  margin: 6px 4px;
  background: #edf0f4;
}
.document-card__body {
  flex: 1;
  min-width: 0;
  padding: 5px 8px 7px;
}
.document-card__title-row {
  min-width: 0;
}
.document-card__title {
  margin: 0;
  color: #172033;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 43px;
  cursor: default;
}
.document-card__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 0px;
  color: #94a3b8;
  font-size: 11px;
}
.document-card__meta-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}
.document-card__meta-item i {
  font-size: 11px;
  color: #94a3b8;
}
.document-card__meta-dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #cbd5e1;
}
.document-card__folder {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 7px 9px;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
}
.document-card__folder-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 6px;
  background: #eef2ff;
  color: #253b80;
}
.document-card__folder-icon i {
  font-size: 11px;
}
.document-card__folder-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.document-card__footer {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 11px 13px;
  border-top: 1px solid #eef1f5;
  background: #fcfdff;
  border-radius: 0 0 16px 16px;
}
.document-action {
  min-width: 0;
  flex: 1;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 9px;
  border: 1px solid #e6eaf0;
  border-radius: 8px;
  background: #ffffff;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.18s ease,
    color 0.18s ease,
    border-color 0.18s ease,
    transform 0.18s ease;
}
.document-action:hover:not(:disabled) {
  transform: translateY(-1px);
}
.document-action:disabled {
  cursor: not-allowed;
}
.document-action__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}
.document-action__label {
  white-space: nowrap;
}
.document-action--preview:hover {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #2563eb;
}
.document-action--publish:hover:not(:disabled) {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #16a34a;
}
.document-action--published {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #15803d;
  opacity: 1;
}
.document-action--published .document-action__icon {
  color: #16a34a;
}
.document-action--summary:hover {
  background: #f5f3ff;
  border-color: #ddd6fe;
  color: #7c3aed;
}
@keyframes documentDropdownIn {
  from {
    opacity: 0;
    transform: translateY(-5px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 1200px) {
  .document-grid {
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  }
}
@media (max-width: 768px) {
  .document-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 14px;
  }
  .document-card__preview {
    min-height: 135px;
  }
  .document-card__footer {
    gap: 5px;
  }
  .document-action {
    padding: 0 7px;
  }
  .document-action .document-action__label {
    font-size: 10px;
  }
}
@media (max-width: 480px) {
  .document-grid {
    grid-template-columns: 1fr;
  }
}
.document-list {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e7eaf0;
  border-radius: 16px;
  overflow: visible;
  box-shadow: 0 4px 18px rgba(20, 30, 50, 0.04);
  max-height: calc(100vh - 361px);
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.document-list::-webkit-scrollbar {
  width: 7px;
}
.document-list::-webkit-scrollbar-track {
  background: transparent;
}
.document-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.document-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.document-list__header {
  display: grid;
  grid-template-columns: 48px minmax(280px, 1.8fr) minmax(150px, 1fr) 100px 140px 110px;
  align-items: center;
  min-height: 52px;
  padding: 0 18px;
  background: #f8f9fc;
  border-bottom: 1px solid #e9ecf2;
  color: #737b8c;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.document-row {
  position: relative;
  display: grid;
  grid-template-columns: 48px minmax(280px, 1.8fr) minmax(150px, 1fr) 100px 140px 110px;
  align-items: center;
  min-height: 76px;
  padding: 8px 18px;
  background: #ffffff;
  border-bottom: 1px solid #f0f1f5;
  transition: background 0.18s ease, box-shadow 0.18s ease;
}
.document-row:last-child {
  border-bottom: none;
}
.document-row:hover {
  background: #fafbfe;
}
.document-row:hover .document-row__icon {
  transform: translateY(-1px);
}
.document-row:hover .action-btn {
  opacity: 1;
}
.document-row--selected {
  background: #f4f7ff;
  box-shadow: inset 3px 0 0 #253b80;
}
.document-row__select,
.col-select {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.list-checkbox {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.list-checkbox input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
.list-checkbox__box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid #cdd2dc;
  border-radius: 5px;
  background: #ffffff;
  transition: all 0.15s ease;
}
.list-checkbox__box i {
  font-size: 10px;
  color: #ffffff;
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.15s ease;
}
input:checked + .list-checkbox__box {
  background: #253b80;
  border-color: #253b80;
}
input:checked + .list-checkbox__box i {
  opacity: 1;
  transform: scale(1);
}
.list-checkbox:hover .list-checkbox__box {
  border-color: #253b80;
}
.document-row__name {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 13px;
}
.document-row__icon {
  flex: 0 0 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 11px;
  transition: transform 0.18s ease;
}
.document-row__icon i {
  font-size: 19px;
}
.document-row__icon.pdf {
  background: #fff1f1;
  color: #dc2626;
}
.document-row__icon.doc,
.document-row__icon.docx {
  background: #eff6ff;
  color: #2563eb;
}
.document-row__icon.xls,
.document-row__icon.xlsx {
  background: #ecfdf3;
  color: #16a34a;
}
.document-row__icon.ppt,
.document-row__icon.pptx {
  background: #fff7ed;
  color: #ea580c;
}
.document-row__icon.txt {
  background: #f5f3ff;
  color: #7c3aed;
}
.document-row__details {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.document-row__details strong {
  display: block;
  overflow: hidden;
  color: #202635;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.document-row__meta {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #8b93a3;
  font-size: 11px;
  font-weight: 500;
}
.document-row__meta .meta-dot {
  color: #c2c7d0;
}
.document-row__folder {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #596274;
  font-size: 13px;
  font-weight: 500;
}
.document-row__folder span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.folder-icon {
  flex: 0 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #fff8e6;
  color: #d89b19;
}
.folder-icon i {
  font-size: 14px;
}
.document-row__size {
  color: #687184;
  font-size: 12px;
  font-weight: 500;
}
.document-row__date {
  color: #687184;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.document-row__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}
.action-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #737b8b;
  cursor: pointer;
  opacity: 0.75;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease,
    transform 0.15s ease;
}
.action-btn i {
  font-size: 14px;
}
.action-btn:hover {
  background: #f1f4fa;
  color: #253b80;
  border-color: #e2e6ef;
  transform: translateY(-1px);
}
.action-btn.is-active {
  background: #eef2ff;
  color: #253b80;
  border-color: #d9e0ff;
}
.document-menu-wrapper {
  position: relative;
  display: flex;
}
.document-action-menu {
  position: absolute;
  z-index: 1000;
  top: calc(100% + 8px);
  right: 0;
  width: 230px;
  padding: 7px;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 13px;
  box-shadow: 0 14px 35px rgba(20, 30, 50, 0.14), 0 3px 10px rgba(20, 30, 50, 0.06);
  animation: documentMenuIn 0.14s ease-out;
}
.document-action-menu__item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px;
  gap: 10px;
  border: none;
  border-radius: 9px;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}
.document-action-menu__item:hover {
  background: #f6f7fa;
}
.document-action-menu__item--danger .menu-content strong {
  color: #dc2626;
}
.document-action-menu__item--danger:hover {
  background: #fff5f5;
}
.menu-icon {
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 9px;
}
.menu-icon i {
  font-size: 14px;
}
.menu-icon--blue {
  background: #eff6ff;
  color: #2563eb;
}
.menu-icon--purple {
  background: #f5f3ff;
  color: #7c3aed;
}
.menu-icon--green {
  background: #ecfdf3;
  color: #16a34a;
}
.menu-icon--orange {
  background: #fff7ed;
  color: #ea580c;
}
.menu-icon--red {
  background: #fff1f2;
  color: #dc2626;
}
.menu-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.menu-content strong {
  color: #303746;
  font-size: 12px;
  font-weight: 650;
}
.menu-content small {
  color: #9299a7;
  font-size: 10px;
  font-weight: 400;
}
.menu-divider {
  height: 1px;
  margin: 6px 4px;
  background: #edf0f4;
}
@keyframes documentMenuIn {
  from {
    opacity: 0;
    transform: translateY(-5px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 1100px) {
  .document-list__header,
  .document-row {
    grid-template-columns: 42px minmax(230px, 1.5fr) minmax(130px, 1fr) 90px 120px 100px;
  }
}
@media (max-width: 900px) {
  .document-list {
    overflow-x: auto;
  }
  .document-list__header,
  .document-row {
    min-width: 850px;
  }
}
@media (max-width: 600px) {
  .document-action-menu {
    right: 0;
    width: 215px;
  }
}
.document-list__header,
.document-row {
  display: grid;
  grid-template-columns: 42px minmax(260px, 2fr) minmax(150px, 1fr) 100px 140px 110px;
  align-items: center;
}
.col-select,
.document-row__select {
  display: flex;
  align-items: center;
  justify-content: center;
}
.list-checkbox {
  position: relative;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.list-checkbox input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
.list-checkbox__box {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #cbd5e1;
  border-radius: 5px;
  background: #ffffff;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease;
}
.list-checkbox__box i {
  display: none;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
}
.list-checkbox:hover .list-checkbox__box {
  border-color: #253b80;
  transform: scale(1.06);
}
.list-checkbox input:checked + .list-checkbox__box {
  background: #253b80;
  border-color: #253b80;
}
.list-checkbox input:checked + .list-checkbox__box i {
  display: block;
}
.document-row--selected {
  background: #f4f6ff;
}
.document-row--selected .document-row__name strong {
  color: #253b80;
}
.document-row__details {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.document-row__details strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1e293b;
  font-size: 14px;
  font-weight: 600;
}
.document-row__details small {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}
.document-row__folder {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #64748b;
  font-size: 13px;
}
.document-row__folder i {
  flex-shrink: 0;
  color: #f59e0b;
}
.document-row__folder span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 1000px) {
  .document-list__header,
  .document-row {
    grid-template-columns: 42px minmax(220px, 2fr) minmax(130px, 1fr) 90px 120px 100px;
  }
}
@media (max-width: 768px) {
  .document-list {
    overflow-x: auto;
  }
  .document-list__header,
  .document-row {
    min-width: 850px;
  }
}
.documents-empty,
.folder-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}
.documents-empty {
  min-height: 420px;
}
.documents-empty__illustration,
.folder-empty__icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: #eef2ff;
  color: var(--primary);
  font-size: 25px;
}
.documents-empty h3,
.folder-empty h4 {
  margin: 15px 0 5px;
}
.documents-empty p,
.folder-empty p {
  max-width: 380px;
  margin: 0 0 17px;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.6;
}
.folder-empty {
  padding: 35px 15px;
}
.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.48);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.modal-card {
  width: min(100%, 520px);
  overflow: hidden;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.2);
  animation: modalIn 0.18s ease-out;
}
@keyframes modalIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.modal-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 18px;
  border-bottom: 1px solid var(--border);
}
.modal-card__header h3 {
  margin: 0;
  font-size: 15px;
}
.modal-card__header p {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 11px;
}
.modal-card__body {
  padding: 20px;
}
.modal-card__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 18px;
  border-top: 1px solid var(--border);
  background: #fafafa;
}
.modal-close {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  right: 5rem;
  top: 3rem;
  background: #f3f4f6;
  color: #6b7280;
  cursor: pointer;
}
.modal-close:hover {
  background: #e5e7eb;
}
.form-control {
  width: 100%;
  height: 42px;
  box-sizing: border-box;
  margin-top: 8px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  outline: none;
  font-size: 12px;
}
.form-control:focus {
  border: 1px solid #9aa8ce !important;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.07) !important;
}
.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.58);
  -webkit-backdrop-filter: blur(7px);
  backdrop-filter: blur(7px);
  animation: summaryBackdropIn 0.2s ease-out;
}
.summary-modal {
  width: min(900px, 100%);
  max-height: min(820px, 100vh - 48px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.22), 0 10px 30px rgba(15, 23, 42, 0.1);
  animation: summaryModalIn 0.25s ease-out;
}
.summary-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 24px;
  border-bottom: 1px solid #eef0f4;
  background:
    linear-gradient(
      180deg,
      #ffffff 0%,
      #fbfcff 100%);
}
.summary-modal__heading {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 14px;
}
.summary-modal__ai-icon {
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  color: #ffffff;
  background:
    linear-gradient(
      135deg,
      #253b80 0%,
      #4f67ae 100%);
  box-shadow: 0 8px 20px rgba(37, 59, 128, 0.22);
  font-size: 20px;
}
.summary-modal__title {
  min-width: 0;
}
.summary-modal__title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.summary-modal__title-row h3 {
  margin: 0;
  color: #172033;
  font-size: 19px;
  line-height: 1.3;
  font-weight: 700;
}
.ai-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 9px;
  border: 1px solid #dbe3ff;
  border-radius: 999px;
  color: #253b80;
  background: #f1f4ff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.01em;
  white-space: nowrap;
}
.ai-badge i {
  font-size: 10px;
}
.summary-modal__document-name {
  max-width: 620px;
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 6px 0 0;
  overflow: hidden;
  color: #64748b;
  font-size: 13px;
  line-height: 1.4;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.summary-modal__document-name i {
  flex: 0 0 auto;
  color: #94a3b8;
  font-size: 13px;
}
.summary-modal__close {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 10px;
  color: #64748b;
  background: #f8fafc;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.summary-modal__close:hover {
  color: #1e293b;
  background: #eef2f7;
  transform: rotate(90deg);
}
.summary-modal__close:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.18);
  outline-offset: 2px;
}
.summary-modal__body {
  min-height: 0;
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  background: #f8fafc;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.summary-modal__body::-webkit-scrollbar {
  width: 6px;
}
.summary-modal__body::-webkit-scrollbar-track {
  background: transparent;
}
.summary-modal__body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.summary-loading {
  min-height: 330px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
}
.summary-loading__icon {
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  color: #253b80;
  background: #eef2ff;
  font-size: 22px;
  animation: summaryPulse 1.5s infinite ease-in-out;
}
.summary-loading__content {
  width: min(420px, 100%);
}
.summary-loading__content h4 {
  margin: 0 0 6px;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
}
.summary-loading__content p {
  margin: 0 0 18px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}
.summary-loading__bar {
  width: 100%;
  height: 5px;
  overflow: hidden;
  border-radius: 10px;
  background: #e8edf5;
}
.summary-loading__bar span {
  display: block;
  width: 45%;
  height: 100%;
  border-radius: inherit;
  background:
    linear-gradient(
      90deg,
      #253b80,
      #7186c2);
  animation: summaryLoadingBar 1.5s infinite ease-in-out;
}
.summary-content {
  width: 100%;
}
.summary-content__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.summary-content__label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}
.summary-content__label i {
  color: #253b80;
}
.summary-content__status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #15803d;
  font-size: 12px;
  font-weight: 600;
}
.summary-content__status i {
  font-size: 13px;
}
.summary-content__paper {
  position: relative;
  min-height: 320px;
  display: flex;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
}
.summary-content__accent {
  width: 4px;
  flex: 0 0 4px;
  background:
    linear-gradient(
      180deg,
      #253b80,
      #7186c2);
}
.summary-content__text {
  flex: 1;
  padding: 26px 30px;
}
.summary-content__text p {
  margin: 0;
  color: #334155;
  font-size: 15px;
  line-height: 1.85;
  white-space: pre-line;
}
.summary-empty {
  min-height: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.summary-empty__icon {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  border-radius: 14px;
  color: #64748b;
  background: #f1f5f9;
  font-size: 20px;
}
.summary-empty h4 {
  margin: 0 0 6px;
  color: #334155;
  font-size: 15px;
  font-weight: 700;
}
.summary-empty p {
  max-width: 360px;
  margin: 0;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.5;
}
.summary-modal__footer {
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 24px;
  border-top: 1px solid #eef0f4;
  background: #ffffff;
}
.summary-footer__info {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #94a3b8;
  font-size: 12px;
}
.summary-footer__info i {
  color: #64748b;
}
.summary-footer__button {
  min-width: 90px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 10px 17px;
  border: 0;
  border-radius: 10px;
  color: #ffffff;
  background: #253b80;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 5px 12px rgba(37, 59, 128, 0.18);
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.summary-footer__button:hover {
  background: #1d2f68;
  transform: translateY(-1px);
  box-shadow: 0 7px 16px rgba(37, 59, 128, 0.24);
}
.summary-footer__button:active {
  transform: translateY(0);
}
@keyframes summaryBackdropIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes summaryModalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes summaryPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.08);
    opacity: 0.75;
  }
}
@keyframes summaryLoadingBar {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(240%);
  }
}
@media (max-width: 768px) {
  .modal-backdrop {
    padding: 14px;
  }
  .summary-modal {
    max-height: calc(100vh - 28px);
    border-radius: 16px;
  }
  .summary-modal__header {
    padding: 18px;
  }
  .summary-modal__body {
    padding: 16px;
  }
  .summary-modal__footer {
    padding: 12px 16px;
  }
  .summary-modal__document-name {
    max-width: 380px;
  }
  .summary-content__text {
    padding: 22px;
  }
  .summary-loading {
    min-height: 280px;
    flex-direction: column;
    text-align: center;
  }
  .summary-loading__content {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .modal-backdrop {
    padding: 8px;
  }
  .summary-modal {
    max-height: calc(100vh - 16px);
    border-radius: 14px;
  }
  .summary-modal__heading {
    gap: 10px;
  }
  .summary-modal__ai-icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    border-radius: 11px;
    font-size: 17px;
  }
  .summary-modal__title-row {
    gap: 6px;
  }
  .summary-modal__title-row h3 {
    font-size: 16px;
  }
  .ai-badge {
    display: none;
  }
  .summary-modal__document-name {
    max-width: 230px;
    font-size: 12px;
  }
  .summary-modal__body {
    padding: 12px;
  }
  .summary-content__paper {
    min-height: 280px;
  }
  .summary-content__text {
    padding: 20px 18px;
  }
  .summary-content__text p {
    font-size: 14px;
    line-height: 1.75;
  }
  .summary-modal__footer {
    align-items: stretch;
    flex-direction: column;
  }
  .summary-footer__info {
    justify-content: center;
  }
  .summary-footer__button {
    width: 100%;
  }
}
.preview-modal {
  width: min(1100px, 95vw);
  height: min(800px, 90vh);
  display: flex;
  flex-direction: column;
}
.preview-modal__body {
  flex: 1;
  min-height: 0;
  background: #f1f3f6;
}
.preview-modal__body iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
.preview-placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #9ca3af;
}
.preview-placeholder i {
  font-size: 45px;
  margin-bottom: 12px;
}
.preview-placeholder h4 {
  margin: 0 0 5px;
  color: #374151;
}
.preview-placeholder p {
  margin: 0;
  font-size: 12px;
}
@media (max-width: 1100px) {
  .documents-page {
    padding: 3px 0px 0px 0px;
  }
  .documents-workspace {
    grid-template-columns: 230px minmax(0, 1fr);
  }
  .document-list__header,
  .document-row {
    grid-template-columns: minmax(200px, 2fr) minmax(120px, 1fr) 80px 100px 100px;
  }
}
@media (max-width: 850px) {
  .documents-page {
    padding: 15px;
  }
  .documents-page__header {
    align-items: flex-start;
    flex-direction: column;
  }
  .documents-workspace {
    grid-template-columns: 1fr;
  }
  .folder-sidebar {
    border-right: 0;
    border-bottom: 1px solid var(--border);
  }
  .folder-list {
    max-height: 240px;
  }
  .documents-content__header {
    align-items: flex-start;
    flex-direction: column;
  }
  .documents-content__actions {
    width: 100%;
    flex-wrap: wrap;
  }
}
@media (max-width: 650px) {
  .documents-page__actions {
    width: 100%;
  }
  .documents-page__actions .btn {
    flex: 1;
  }
  .documents-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .documents-search {
    width: 100%;
  }
  .documents-toolbar__right {
    justify-content: space-between;
  }
  .document-grid {
    grid-template-columns: 1fr;
  }
  .document-list {
    overflow-x: auto;
  }
  .document-list__header,
  .document-row {
    min-width: 700px;
  }
}
.folder-modal {
  width: min(560px, 100vw - 32px);
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.2);
  animation: folderModalIn 0.2s ease-out;
}
.modal-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 22px;
  border-bottom: 1px solid #e5e7eb;
}
.modal-card__heading {
  display: flex;
  align-items: flex-start;
  gap: 13px;
}
.modal-card__icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eef2ff;
  color: #253b80;
  font-size: 18px;
}
.modal-card__heading h3 {
  margin: 0;
  color: #111827;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.4;
}
.modal-card__heading p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.5;
}
.modal-close {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}
.modal-close:hover {
  background: #f1f5f9;
  color: #111827;
}
.modal-card__body {
  padding: 22px;
  overflow-y: auto;
}
.form-group {
  margin-bottom: 20px;
}
.form-group:last-child {
  margin-bottom: 0;
}
.form-group > label {
  display: block;
  margin-bottom: 7px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}
.required {
  margin-left: 2px;
  color: #dc2626;
}
.input-wrapper,
.select-wrapper {
  position: relative;
}
.input-wrapper > i,
.select-wrapper > i:first-child {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  pointer-events: none;
}
.input-wrapper .form-control {
  padding-left: 40px;
}
.form-control {
  width: 100%;
  min-height: 42px;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #ffffff;
  color: #1f2937;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.form-control:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.1);
}
textarea.form-control {
  min-height: 82px;
  resize: vertical;
}
.select-wrapper .form-control {
  appearance: none;
  padding-left: 40px;
  padding-right: 40px;
  cursor: pointer;
}
.select-arrow {
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  pointer-events: none;
}
.form-hint {
  display: block;
  margin-top: 5px;
  color: #94a3b8;
  font-size: 11px;
}
.field-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.character-count {
  color: #94a3b8;
  font-size: 11px;
}
.access-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.access-option {
  position: relative;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;
}
.access-option:hover {
  border-color: #b8c3df;
  background: #f8fafc;
}
.access-option.active {
  border-color: #253b80;
  background: #f5f7ff;
  box-shadow: 0 0 0 1px rgba(37, 59, 128, 0.08);
}
.access-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.access-option__icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 15px;
}
.access-option__icon.private {
  background: #fef3c7;
  color: #b45309;
}
.access-option__icon.users {
  background: #e0e7ff;
  color: #4338ca;
}
.access-option__icon.public {
  background: #dcfce7;
  color: #15803d;
}
.access-option__content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.access-option__content strong {
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
}
.access-option__content span {
  margin-top: 2px;
  color: #64748b;
  font-size: 11px;
  line-height: 1.4;
}
.access-option__check {
  margin-left: auto;
  color: #253b80;
  font-size: 15px;
}
.selected-users {
  padding: 14px;
  border-radius: 10px;
  background: #f8fafc;
}
.selected-users select {
  min-height: 100px;
}
.modal-card__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 22px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
}
.btn {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 9px 16px;
  border: 0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-light {
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #475569;
}
.btn-light:hover {
  background: #f8fafc;
}
.btn-primary {
  background: #253b80;
  color: #ffffff;
}
.btn-primary:hover:not(:disabled) {
  background: #1d2f68;
}
.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.55);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
@keyframes folderModalIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 576px) {
  .folder-modal {
    width: 100%;
    max-height: calc(100vh - 20px);
    border-radius: 12px;
  }
  .modal-card__header,
  .modal-card__body,
  .modal-card__footer {
    padding-left: 16px;
    padding-right: 16px;
  }
  .modal-card__footer {
    flex-direction: column-reverse;
  }
  .modal-card__footer .btn {
    width: 100%;
  }
}
.selected-users {
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}
.user-search {
  position: relative;
}
.user-search > i {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  pointer-events: none;
}
.user-search .form-control {
  padding-left: 40px;
  padding-right: 38px;
  background: #ffffff;
}
.user-search__clear {
  position: absolute;
  right: 9px;
  top: 50%;
  width: 28px;
  height: 28px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}
.user-search__clear:hover {
  background: #f1f5f9;
  color: #1e293b;
}
.selected-users__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 2px;
  color: #64748b;
  font-size: 12px;
}
.selected-users__summary span {
  display: flex;
  align-items: center;
  gap: 5px;
}
.selected-users__summary i {
  color: #253b80;
}
.clear-users {
  padding: 0;
  border: 0;
  background: transparent;
  color: #253b80;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.clear-users:hover {
  text-decoration: underline;
}
.user-selection-list {
  max-height: 220px;
  overflow-y: auto;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #ffffff;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.user-selection-list::-webkit-scrollbar {
  width: 5px;
}
.user-selection-list::-webkit-scrollbar-track {
  background: transparent;
}
.user-selection-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.user-selection-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.user-selection-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 56px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.user-selection-item:hover {
  background: #f8fafc;
}
.user-selection-item.selected {
  background: #f5f7ff;
}
.user-selection-item > input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.user-avatar {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  background: #e8ecf7;
  color: #253b80;
  font-size: 12px;
  font-weight: 700;
}
.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.user-info strong {
  overflow: hidden;
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-info small {
  margin-top: 2px;
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-check {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #cbd5e1;
  border-radius: 6px;
  color: #ffffff;
  transition: all 0.15s ease;
}
.user-selection-item.selected .user-check {
  border-color: #253b80;
  background: #253b80;
}
.user-check i {
  font-size: 11px;
  font-weight: 700;
}
.no-users {
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #94a3b8;
  text-align: center;
}
.no-users i {
  margin-bottom: 3px;
  font-size: 22px;
}
.no-users span {
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}
.no-users small {
  font-size: 11px;
}
.document-preview-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.62);
  -webkit-backdrop-filter: blur(7px);
  backdrop-filter: blur(7px);
  animation: previewBackdropIn 0.2s ease;
}
.document-preview-modal {
  width: min(1500px, 96vw);
  height: min(900px, 92vh);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.2);
  animation: previewModalIn 0.25s ease;
}
.document-preview-modal__header {
  min-height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.document-preview-modal__brand {
  display: flex;
  align-items: center;
  gap: 13px;
}
.document-preview-modal__brand-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #253b80;
  background: #eef2ff;
  border: 1px solid #dce4ff;
  border-radius: 12px;
  font-size: 19px;
}
.document-preview-modal__brand-content h3 {
  margin: 0;
  color: #172033;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.35;
}
.document-preview-modal__brand-content p {
  margin: 3px 0 0;
  color: #667085;
  font-size: 12px;
  font-weight: 500;
}
.header-dot {
  margin: 0 5px;
  color: #98a2b3;
}
.modal-close {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 9px;
  cursor: pointer;
  transition:
    color 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease;
}
.modal-close:hover {
  color: #dc2626;
  background: #fef2f2;
  border-color: #fee2e2;
}
.modal-close:active {
  transform: scale(0.96);
}
.document-preview-modal__content {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 310px minmax(0, 1fr);
  overflow: hidden;
  background: #f5f7fb;
}
.document-preview-sidebar {
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
}
.document-preview-sidebar__header {
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #edf0f4;
}
.document-preview-sidebar__header h4 {
  margin: 0;
  color: #172033;
  font-size: 13px;
  font-weight: 700;
}
.document-preview-sidebar__header span {
  display: block;
  margin-top: 3px;
  color: #98a2b3;
  font-size: 11px;
  font-weight: 500;
}
.document-count-badge {
  width: 30px;
  height: 30px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  color: #253b80 !important;
  background: #eef2ff;
  border-radius: 8px;
  font-size: 11px !important;
  font-weight: 700 !important;
}
.document-preview-sidebar__list {
  flex: 1;
  min-height: 0;
  padding: 8px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #d0d5dd transparent;
}
.document-preview-sidebar__list::-webkit-scrollbar {
  width: 5px;
}
.document-preview-sidebar__list::-webkit-scrollbar-track {
  background: transparent;
}
.document-preview-sidebar__list::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 10px;
}
.preview-document-item {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 11px 10px;
  margin-bottom: 3px;
  text-align: left;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    transform 0.18s ease;
}
.preview-document-item:hover {
  background: #f8fafc;
  border-color: #edf0f4;
}
.preview-document-item:active {
  transform: scale(0.995);
}
.preview-document-item--active {
  background: #f1f4ff;
  border-color: #dbe3ff;
}
.preview-document-item--active .preview-document-item__name {
  color: #1d2f68;
  font-weight: 700;
}
.preview-document-item--active .preview-document-item__icon {
  border-color: #ccd7ff;
}
.preview-document-item__icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #253b80;
  background: #f5f7ff;
  border: 1px solid #e5e7eb;
  border-radius: 9px;
  font-size: 16px;
}
.preview-document-item__icon.pdf,
.preview-document-item__icon.file-pdf {
  color: #dc2626;
  background: #fef2f2;
}
.preview-document-item__icon.word,
.preview-document-item__icon.file-word {
  color: #2563eb;
  background: #eff6ff;
}
.preview-document-item__icon.excel,
.preview-document-item__icon.file-excel {
  color: #16a34a;
  background: #f0fdf4;
}
.preview-document-item__icon.image,
.preview-document-item__icon.file-image {
  color: #9333ea;
  background: #faf5ff;
}
.preview-document-item__icon.audio,
.preview-document-item__icon.file-audio {
  color: #db2777;
  background: #fdf2f8;
}
.preview-document-item__icon.video,
.preview-document-item__icon.file-video {
  color: #ea580c;
  background: #fff7ed;
}
.preview-document-item__content {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.preview-document-item__name {
  display: block;
  overflow: hidden;
  color: #172033;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.preview-document-item__meta {
  display: flex !important;
  align-items: center;
  gap: 5px;
  color: #98a2b3 !important;
  font-size: 10px !important;
  font-weight: 500 !important;
  white-space: nowrap;
}
.meta-separator {
  margin: 0 !important;
  color: #c4c9d2 !important;
}
.preview-document-item__active-indicator {
  width: 20px;
  height: 20px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  color: #253b80 !important;
  background: #dfe6ff;
  border-radius: 50%;
  font-size: 9px !important;
}
.document-preview-sidebar__empty {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 25px;
  text-align: center;
}
.document-preview-sidebar__empty .empty-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  color: #98a2b3;
  background: #f2f4f7;
  border-radius: 12px;
  font-size: 19px;
}
.document-preview-sidebar__empty h5 {
  margin: 0;
  color: #172033;
  font-size: 13px;
}
.document-preview-sidebar__empty p {
  margin: 5px 0 0;
  color: #98a2b3;
  font-size: 11px;
}
.document-preview-main {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #f5f7fb;
}
.document-preview-main__header {
  min-height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 13px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.document-preview-main__title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.document-preview-main__file-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #253b80;
  background: #eef2ff;
  border: 1px solid #dbe3ff;
  border-radius: 10px;
  font-size: 18px;
}
.document-preview-main__file-info {
  min-width: 0;
}
.document-preview-main__file-info h3 {
  max-width: 600px;
  margin: 0;
  overflow: hidden;
  color: #172033;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.document-preview-main__file-info p {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 4px 0 0;
  color: #98a2b3;
  font-size: 10px;
  font-weight: 500;
}
.title-separator {
  color: #c4c9d2;
}
.document-preview-navigation {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.preview-nav-button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition:
    color 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease;
}
.preview-nav-button:hover:not(:disabled) {
  color: #253b80;
  background: #eef2ff;
  border-color: #ccd7ff;
}
.preview-nav-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.preview-counter {
  min-width: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #667085;
  font-size: 11px;
}
.preview-counter strong {
  color: #253b80;
  font-weight: 700;
}
.document-preview-main__body {
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 20px;
  overflow: hidden;
}
.media-viewer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}
.media-viewer--video {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111827;
  border-color: #111827;
}
.media-viewer--video .media-viewer__content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.media-viewer--video vg-player {
  width: 100%;
  height: 100%;
}
.media-viewer--video video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #111827;
}
.media-viewer--audio {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 35px;
  background:
    radial-gradient(
      circle at top right,
      #eef2ff 0,
      transparent 40%),
    #ffffff;
}
.audio-preview-card {
  width: min(620px, 90%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.audio-preview-card__artwork {
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 22px;
  background: #eef2ff;
  border: 1px solid #dce4ff;
  border-radius: 50%;
}
.audio-preview-card__icon {
  width: 105px;
  height: 105px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: #253b80;
  border-radius: 50%;
  box-shadow: 0 12px 30px rgba(37, 59, 128, 0.22);
  font-size: 38px;
}
.audio-preview-card__info .audio-preview-card__label {
  color: #253b80;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1.2px;
}
.audio-preview-card__info h4 {
  max-width: 500px;
  margin: 7px 0 5px;
  overflow: hidden;
  color: #172033;
  font-size: 18px;
  font-weight: 700;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audio-preview-card__info p {
  margin: 0 0 20px;
  color: #667085;
  font-size: 12px;
}
.audio-player {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}
.media-viewer--image {
  display: flex;
  flex-direction: column;
  background: #f8fafc;
}
.image-viewer__toolbar {
  min-height: 42px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.image-viewer__toolbar span {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #667085;
  font-size: 11px;
  font-weight: 600;
}
.image-viewer__toolbar span i {
  color: #253b80;
}
.image-viewer__canvas {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  overflow: auto;
}
.viewer-image {
  max-width: 100%;
  max-height: 100%;
  display: block;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.12);
}
.media-viewer--document {
  display: flex;
  flex-direction: column;
  background: #eef1f5;
}
.document-viewer__toolbar {
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.document-viewer__toolbar > div {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #667085;
  font-size: 11px;
  font-weight: 600;
}
.document-viewer__toolbar > div i {
  color: #253b80;
}
.document-viewer__secure {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #16a34a;
  font-size: 10px;
  font-weight: 600;
}
.document-viewer__secure i {
  font-size: 10px;
}
.document-viewer__content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.document-viewer__content ngx-doc-viewer {
  width: 100%;
  height: 100%;
}
.preview-placeholder {
  width: min(430px, 90%);
  align-self: center;
  padding: 45px 30px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}
.preview-placeholder__illustration {
  width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  background: #eef2ff;
  border-radius: 20px;
}
.preview-placeholder__icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #253b80;
  background: #ffffff;
  border: 1px solid #dce4ff;
  border-radius: 13px;
  font-size: 21px;
}
.preview-placeholder h4 {
  margin: 0;
  color: #172033;
  font-size: 15px;
  font-weight: 700;
}
.preview-placeholder p {
  max-width: 320px;
  margin: 8px auto 4px;
  color: #667085;
  font-size: 12px;
  line-height: 1.6;
}
.preview-placeholder > span {
  color: #98a2b3;
  font-size: 10px;
}
@keyframes previewBackdropIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes previewModalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 1000px) {
  .document-preview-modal {
    width: 96vw;
    height: 94vh;
  }
  .document-preview-modal__content {
    grid-template-columns: 260px minmax(0, 1fr);
  }
  .document-preview-main__file-info h3 {
    max-width: 350px;
  }
}
@media (max-width: 760px) {
  .document-preview-backdrop {
    padding: 0;
  }
  .document-preview-modal {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
  }
  .document-preview-modal__header {
    min-height: 68px;
    padding: 12px 14px;
  }
  .document-preview-modal__brand-icon {
    width: 38px;
    height: 38px;
  }
  .document-preview-modal__brand-content h3 {
    font-size: 15px;
  }
  .document-preview-modal__brand-content p {
    font-size: 10px;
  }
  .document-preview-modal__content {
    display: flex;
    flex-direction: column;
  }
  .document-preview-sidebar {
    flex: 0 0 170px;
    border-right: 0;
    border-bottom: 1px solid #e5e7eb;
  }
  .document-preview-sidebar__header {
    min-height: 52px;
  }
  .document-preview-sidebar__list {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 7px;
  }
  .preview-document-item {
    width: 220px;
    flex-shrink: 0;
    margin-right: 4px;
    margin-bottom: 0;
  }
  .document-preview-main {
    min-height: 0;
  }
  .document-preview-main__header {
    min-height: 66px;
    padding: 10px 12px;
  }
  .document-preview-main__file-icon {
    width: 36px;
    height: 36px;
  }
  .document-preview-main__file-info h3 {
    max-width: 190px;
    font-size: 12px;
  }
  .document-preview-main__body {
    padding: 10px;
  }
  .preview-counter {
    display: none;
  }
  .preview-nav-button {
    width: 34px;
    height: 34px;
  }
}
@media (max-width: 480px) {
  .document-preview-sidebar {
    flex-basis: 150px;
  }
  .preview-document-item {
    width: 200px;
  }
  .preview-document-item__icon {
    width: 34px;
    height: 34px;
  }
  .document-preview-main__title {
    gap: 8px;
  }
  .document-preview-main__file-info h3 {
    max-width: 145px;
  }
  .document-preview-main__body {
    padding: 7px;
  }
  .media-viewer--audio {
    padding: 20px 10px;
  }
  .audio-preview-card__artwork {
    width: 110px;
    height: 110px;
  }
  .audio-preview-card__icon {
    width: 78px;
    height: 78px;
    font-size: 28px;
  }
  .audio-preview-card__info h4 {
    max-width: 280px;
    font-size: 15px;
  }
  .preview-placeholder {
    padding: 30px 18px;
  }
}
.document-preview-modal {
  width: min(1400px, 96vw);
  height: min(850px, 92vh);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.25);
  animation: previewModalIn 0.2s ease-out;
}
.document-preview-modal__header {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #e9edf3;
  background: #ffffff;
  flex-shrink: 0;
}
.document-preview-modal__brand {
  display: flex;
  align-items: center;
  gap: 12px;
}
.document-preview-modal__brand-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eef2ff;
  color: #253b80;
}
.document-preview-modal__brand-icon i {
  font-size: 18px;
}
.document-preview-modal__brand h3 {
  margin: 0;
  color: #172033;
  font-size: 15px;
  font-weight: 700;
}
.document-preview-modal__brand p {
  margin: 3px 0 0;
  color: #94a3b8;
  font-size: 11px;
}
.modal-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9px;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
  transition: all 0.18s ease;
}
.modal-close:hover {
  background: #fee2e2;
  color: #dc2626;
}
.document-preview-modal__content {
  flex: 1;
  min-height: 0;
  display: flex;
}
.document-preview-sidebar {
  width: 310px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  background: #f8fafc;
  border-right: 1px solid #e5e9f0;
}
.document-preview-sidebar__header {
  height: 58px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-bottom: 1px solid #e5e9f0;
  flex-shrink: 0;
}
.document-preview-sidebar__header h4 {
  margin: 0;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}
.document-preview-sidebar__header span {
  display: block;
  margin-top: 2px;
  color: #94a3b8;
  font-size: 10px;
}
.document-preview-sidebar__list {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.document-preview-sidebar__list::-webkit-scrollbar {
  width: 6px;
}
.document-preview-sidebar__list::-webkit-scrollbar-track {
  background: transparent;
}
.document-preview-sidebar__list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.preview-document-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 10px;
  margin-bottom: 5px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: all 0.16s ease;
}
.preview-document-item:hover {
  background: #ffffff;
  border-color: #e5e7eb;
}
.preview-document-item--active {
  background: #ffffff;
  border-color: #c7d2fe;
  box-shadow: 0 2px 7px rgba(79, 70, 229, 0.08);
}
.preview-document-item--active .preview-document-item__name {
  color: #3730a3;
}
.preview-document-item__icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 9px;
  background: #eef2ff;
  color: #253b80;
}
.preview-document-item__icon i {
  font-size: 16px;
}
.preview-document-item__content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.preview-document-item__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}
.preview-document-item__meta {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #94a3b8;
  font-size: 10px;
}
.document-preview-main {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #eef1f5;
}
.document-preview-main__header {
  min-height: 66px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 10px 16px;
  background: #ffffff;
  border-bottom: 1px solid #e5e9f0;
  flex-shrink: 0;
}
.document-preview-main__title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.document-preview-main__file-icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 9px;
  background: #eef2ff;
  color: #253b80;
}
.document-preview-main__title h3 {
  max-width: 550px;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
}
.document-preview-main__title p {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 0;
  color: #94a3b8;
  font-size: 10px;
}
.document-preview-navigation {
  display: flex;
  align-items: center;
  gap: 9px;
  flex-shrink: 0;
}
.preview-nav-button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition: all 0.18s ease;
}
.preview-nav-button:hover:not(:disabled) {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #253b80;
}
.preview-nav-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.preview-counter {
  min-width: 45px;
  text-align: center;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}
.document-preview-main__body {
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  overflow: hidden;
  background: #eef1f5;
}
.media-viewer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}
.media-viewer--video vg-player {
  width: 100%;
  height: 100%;
  max-width: 1100px;
  max-height: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #111827;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.15);
}
.media-viewer--video video {
  width: 100%;
  height: 100%;
  max-height: calc(92vh - 180px);
  object-fit: contain;
  background: #111827;
}
.media-viewer--audio {
  align-items: center;
  justify-content: center;
}
.audio-player {
  width: min(650px, 90%);
  padding: 35px 30px 20px;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.1);
}
.audio-artwork {
  min-height: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}
.audio-artwork__circle {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eef2ff;
  color: #4f46e5;
  box-shadow: 0 8px 20px rgba(79, 70, 229, 0.12);
}
.audio-artwork__circle i {
  font-size: 34px;
}
.media-viewer--image {
  overflow: auto;
  padding: 10px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.media-viewer--image::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.media-viewer--image::-webkit-scrollbar-track {
  background: transparent;
}
.media-viewer--image::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.viewer-image {
  display: block;
  max-width: 100%;
  max-height: calc(92vh - 170px);
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.12);
  background: #ffffff;
}
.media-viewer--document {
  align-items: stretch;
  justify-content: stretch;
  padding: 0;
}
.media-viewer--document ngx-doc-viewer {
  width: 100%;
  height: 100%;
  display: block;
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.08);
}
.preview-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.06);
}
.preview-placeholder__icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: #f1f5f9;
  color: #94a3b8;
}
.preview-placeholder__icon i {
  font-size: 30px;
}
.preview-placeholder h4 {
  margin: 16px 0 6px;
  color: #334155;
  font-size: 15px;
  font-weight: 700;
}
.preview-placeholder p {
  max-width: 350px;
  margin: 0;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .document-preview-main__body {
    padding: 10px;
  }
  .audio-player {
    width: 95%;
    padding: 25px 18px 15px;
  }
  .audio-artwork {
    min-height: 150px;
  }
  .audio-artwork__circle {
    width: 70px;
    height: 70px;
  }
  .audio-artwork__circle i {
    font-size: 27px;
  }
}
.preview-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #ffffff;
  border-radius: 10px;
  color: #64748b;
}
.preview-placeholder h4 {
  margin: 14px 0 5px;
  color: #334155;
  font-size: 15px;
}
.preview-placeholder p {
  margin: 0;
  color: #94a3b8;
  font-size: 12px;
}
.preview-placeholder__icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #f1f5f9;
  color: #94a3b8;
}
.preview-placeholder__icon i {
  font-size: 28px;
}
@keyframes previewModalIn {
  from {
    opacity: 0;
    transform: scale(0.97) translateY(8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@media (max-width: 900px) {
  .document-preview-sidebar {
    width: 250px;
  }
  .document-preview-main__title h3 {
    max-width: 300px;
  }
}
@media (max-width: 700px) {
  .document-preview-modal {
    width: 96vw;
    height: 94vh;
  }
  .document-preview-sidebar {
    width: 210px;
  }
  .preview-document-item__meta {
    display: none;
  }
  .document-preview-main__header {
    padding: 10px;
  }
  .document-preview-main__title h3 {
    max-width: 180px;
  }
}
.document-selection-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 48px;
  padding: 10px 14px;
  margin-bottom: 18px;
  background: #ffffff;
}
.document-select-all {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.document-select-all input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.document-select-all__box {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #cbd5e1;
  border-radius: 5px;
  background: #ffffff;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.document-select-all__box::after {
  content: "\2713";
  display: none;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}
.document-select-all input:checked + .document-select-all__box {
  background: #253b80;
  border-color: #253b80;
}
.document-select-all input:checked + .document-select-all__box::after {
  display: block;
}
.document-selection-count {
  padding-left: 4px;
  font-size: 13px;
  color: #64748b;
}
.bulk-action-btn {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: #fff1f2;
  color: #dc2626;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.bulk-action-btn:hover {
  background: #fee2e2;
}
.bulk-action-btn i {
  font-size: 13px;
}
.document-card {
  position: relative;
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}
.document-card--selected {
  border-color: #253b80 !important;
  box-shadow: 0 0 0 2px rgba(37, 59, 128, 0.12), 0 8px 24px rgba(37, 59, 128, 0.08);
}
.document-card__checkbox {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.document-card__checkbox input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.document-card__checkbox-box {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid rgba(255, 255, 255, 0.85);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.15);
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease;
}
.document-card__checkbox-box i {
  display: none;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
}
.document-card__checkbox:hover .document-card__checkbox-box {
  transform: scale(1.08);
}
.document-card__checkbox input:checked + .document-card__checkbox-box {
  background: #253b80;
  border-color: #253b80;
}
.document-card__checkbox input:checked + .document-card__checkbox-box i {
  display: block;
}
@media (max-width: 768px) {
  .document-selection-bar {
    flex-wrap: wrap;
    gap: 10px;
  }
  .document-selection-count {
    width: 100%;
    order: 3;
  }
  .bulk-action-btn {
    margin-left: auto;
  }
}
.folder-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.58);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  animation: folderBackdropIn 0.2s ease;
}
.folder-modal-card {
  width: min(720px, 100%);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.22), 0 8px 24px rgba(15, 23, 42, 0.08);
  animation: folderModalIn 0.25s ease;
}
.folder-modal-header {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 24px;
  background:
    linear-gradient(
      180deg,
      #f8faff 0%,
      #ffffff 100%);
  border-bottom: 1px solid #edf0f5;
}
.folder-modal-title {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
}
.folder-modal-title__icon {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eef2ff;
  color: #253b80;
  font-size: 20px;
  transition: all 0.2s ease;
}
.folder-modal-title__icon.edit {
  background: #f0fdf4;
  color: #15803d;
}
.folder-modal-title__content {
  min-width: 0;
}
.folder-modal-title__badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}
.folder-modal-title__badge i {
  font-size: 11px;
}
.folder-modal-title h3 {
  margin: 0;
  color: #172033;
  font-size: 20px;
  font-weight: 750;
  line-height: 1.25;
}
.folder-modal-title p {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}
.folder-modal-close {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9px;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.folder-modal-close:hover {
  background: #e2e8f0;
  color: #1e293b;
  transform: rotate(4deg);
}
.folder-modal-close:active {
  transform: scale(0.94);
}
.folder-modal-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.folder-modal-body::-webkit-scrollbar {
  width: 6px;
}
.folder-modal-body::-webkit-scrollbar-track {
  background: transparent;
}
.folder-modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.form-section {
  padding: 18px;
  background: #fbfcfe;
  border: 1px solid #edf0f5;
  border-radius: 14px;
}
.form-section + .form-section {
  margin-top: 16px;
}
.form-section-heading {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin-bottom: 18px;
}
.form-section-heading__icon {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef2ff;
  color: #253b80;
  font-size: 15px;
}
.form-section-heading__icon.ai {
  background: #faf5ff;
  color: #7c3aed;
}
.form-section-heading__icon.access {
  background: #ecfdf5;
  color: #15803d;
}
.form-section-heading h4 {
  margin: 0;
  color: #1e293b;
  font-size: 14px;
  font-weight: 750;
}
.form-section-heading p {
  margin: 3px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}
.form-group + .form-group {
  margin-top: 18px;
}
.form-group label {
  display: block;
  margin-bottom: 7px;
  color: #334155;
  font-size: 13px;
  font-weight: 650;
}
.required {
  margin-left: 2px;
  color: #dc2626;
}
.label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.label-row label {
  margin-bottom: 7px;
}
.optional-label {
  margin-bottom: 7px;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
}
.input-wrapper {
  position: relative;
}
.input-icon {
  position: absolute;
  top: 50%;
  left: 13px;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 14px;
  pointer-events: none;
}
.form-control {
  width: 100%;
  min-height: 42px;
  padding: 10px 13px;
  border: 1px solid #d9dee8;
  border-radius: 9px;
  background: #ffffff;
  color: #1e293b;
  font-family: inherit;
  font-size: 13px;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}
.form-control::placeholder {
  color: #a1aab8;
}
.form-control:hover {
  border-color: #b8c1d1;
}
.form-control:focus {
  border-color: #5268aa;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.09);
  background: #ffffff;
}
.input-wrapper .form-control {
  padding-left: 39px;
  padding-right: 60px;
}
.input-counter {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 10px;
  font-weight: 600;
  pointer-events: none;
}
.textarea-control {
  min-height: 88px;
  resize: vertical;
  line-height: 1.55;
}
.form-hint {
  display: block;
  margin-top: 6px;
  color: #94a3b8;
  font-size: 11px;
  line-height: 1.4;
}
.field-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.character-count {
  flex-shrink: 0;
  margin-top: 6px;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 600;
}
.model-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}
.model-option {
  position: relative;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px;
  margin: 0 !important;
  border: 1px solid #e1e6ef;
  border-radius: 11px;
  background: #ffffff;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.model-option:hover {
  border-color: #b8c3dc;
  background: #fafbff;
}
.model-option.active {
  border-color: #5268aa;
  background: #f6f8ff;
  box-shadow: 0 0 0 2px rgba(37, 59, 128, 0.06);
}
.model-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.model-option__radio {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #cbd5e1;
  border-radius: 50%;
}
.model-option__radio span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: transparent;
}
.model-option.active .model-option__radio {
  border-color: #253b80;
}
.model-option.active .model-option__radio span {
  background: #253b80;
}
.model-option__icon {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f3f0ff;
  color: #7c3aed;
  font-size: 13px;
}
.model-option__content {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.model-option__content strong {
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}
.model-option__content small {
  overflow: hidden;
  color: #94a3b8;
  font-size: 10px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.model-option__check {
  color: #253b80;
  font-size: 12px;
}
.access-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.access-option {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 12px;
  margin: 0 !important;
  border: 1px solid #e1e6ef;
  border-radius: 11px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
}
.access-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.access-option:hover {
  border-color: #b8c3dc;
  background: #fafbff;
}
.access-option.active {
  border-color: #5268aa;
  background: #f6f8ff;
}
.access-option__icon {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  font-size: 14px;
}
.access-option__icon.users {
  background: #eff6ff;
  color: #2563eb;
}
.access-option__icon.public {
  background: #ecfdf5;
  color: #15803d;
}
.access-option__content {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.access-option__content strong {
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}
.access-option__content span {
  color: #94a3b8;
  font-size: 10px;
  line-height: 1.35;
}
.access-option__radio {
  width: 19px;
  height: 19px;
  flex: 0 0 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 50%;
  color: #ffffff;
  font-size: 9px;
}
.access-option.active .access-option__radio {
  border-color: #253b80;
  background: #253b80;
}
.selected-users-panel {
  margin-top: 14px;
  border: 1px solid #e1e6ef;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}
.selected-users-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 13px 14px;
  border-bottom: 1px solid #edf0f5;
}
.selected-users-panel__header > div:first-child {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.selected-users-panel__header > div:first-child strong {
  color: #334155;
  font-size: 12px;
}
.selected-users-panel__header > div:first-child span {
  color: #94a3b8;
  font-size: 10px;
}
.selected-count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border-radius: 20px;
  background: #eef2ff;
  color: #253b80;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}
.user-search {
  position: relative;
  display: flex;
  align-items: center;
  margin: 12px;
}
.user-search i.pi-search {
  position: absolute;
  left: 12px;
  color: #94a3b8;
  font-size: 13px;
}
.user-search input {
  width: 100%;
  height: 38px;
  padding: 8px 38px 8px 35px;
  border: 1px solid #dfe4ec;
  border-radius: 8px;
  outline: none;
  color: #334155;
  font-family: inherit;
  font-size: 12px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.user-search input:focus {
  border-color: #5268aa;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.07);
}
.user-search button {
  position: absolute;
  right: 8px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
}
.user-search button i {
  font-size: 10px;
}
.user-search button:hover {
  background: #e2e8f0;
}
.user-list {
  max-height: 210px;
  overflow-y: auto;
  padding: 0 12px 12px;
  scrollbar-width: thin;
}
.user-selection-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px;
  border: 1px solid transparent;
  border-radius: 9px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.user-selection-item + .user-selection-item {
  margin-top: 3px;
}
.user-selection-item:hover {
  background: #f8fafc;
}
.user-selection-item.selected {
  border-color: #dce3f5;
  background: #f7f8ff;
}
.user-selection-item > input {
  width: 15px;
  height: 15px;
  flex: 0 0 15px;
  accent-color: #253b80;
  cursor: pointer;
}
.user-avatar {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  background: #e8edf8;
  color: #253b80;
  font-size: 11px;
  font-weight: 750;
}
.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-info {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.user-info strong {
  overflow: hidden;
  color: #334155;
  font-size: 12px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-info small {
  overflow: hidden;
  color: #94a3b8;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-check {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d8dee8;
  border-radius: 6px;
  color: #ffffff;
  font-size: 10px;
}
.user-selection-item.selected .user-check {
  border-color: #253b80;
  background: #253b80;
}
.empty-users {
  min-height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  color: #94a3b8;
}
.empty-users i {
  margin-bottom: 4px;
  font-size: 22px;
}
.empty-users strong {
  color: #64748b;
  font-size: 12px;
}
.empty-users span {
  font-size: 10px;
}
.folder-modal-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 15px 24px;
  background: #ffffff;
  border-top: 1px solid #edf0f5;
}
.footer-info {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  color: #94a3b8;
  font-size: 10px;
}
.footer-info i {
  flex: 0 0 auto;
  color: #64748b;
  font-size: 11px;
}
.footer-info span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.footer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.btn {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 8px 15px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.15s ease;
}
.btn:active:not(:disabled) {
  transform: translateY(1px);
}
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn-cancel {
  border-color: #dfe4ec;
  background: #ffffff;
  color: #475569;
}
.btn-cancel:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.btn-primary {
  min-width: 130px;
  border-color: #253b80;
  background: #253b80;
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(37, 59, 128, 0.16);
}
.btn-primary:hover:not(:disabled) {
  background: #1d2f68;
  border-color: #1d2f68;
  box-shadow: 0 6px 14px rgba(37, 59, 128, 0.22);
}
.btn-primary.loading {
  min-width: 150px;
}
@keyframes folderBackdropIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes folderModalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 700px) {
  .folder-modal-backdrop {
    padding: 12px;
    align-items: flex-end;
  }
  .folder-modal-card {
    max-height: calc(100vh - 24px);
    border-radius: 18px 18px 12px 12px;
  }
  .folder-modal-header {
    padding: 18px;
  }
  .folder-modal-body {
    padding: 16px;
  }
  .folder-modal-footer {
    padding: 13px 16px;
    flex-direction: column;
    align-items: stretch;
  }
  .footer-info {
    display: none;
  }
  .footer-actions {
    width: 100%;
  }
  .footer-actions .btn {
    flex: 1;
  }
  .model-options,
  .access-options {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 450px) {
  .folder-modal-title__icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    font-size: 17px;
  }
  .folder-modal-title h3 {
    font-size: 17px;
  }
  .folder-modal-title p {
    font-size: 11px;
  }
  .form-section {
    padding: 14px;
  }
  .selected-users-panel__header {
    align-items: flex-start;
    flex-direction: column;
  }
}
.documents-container {
  position: relative;
  min-height: 300px;
}
.documents-loader {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.88);
  color: #253b80;
  font-size: 14px;
  font-weight: 500;
}
.loader-spinner {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eef2ff;
}
.loader-spinner i {
  font-size: 22px;
  color: #253b80;
}
/*# sourceMappingURL=documents.component.css.map */
